export default "__VITE_PUBLIC_ASSET__fbe5afc2__"